<template>
  <v-snackbar
    :value="globalStore.snackBar.open"
    color="white"
    rounded="pill"
    @input="snackbarClose"
    bottom
  >
    <div class="text-dark">{{ globalStore.snackBar.message }}</div>
    <template v-slot:action="{ attrs }" v-if="globalStore.snackBar.closeButton">
      <v-btn color="primary" text v-bind="attrs" @click="globalStore.snackBar.open = false">
        Cerrar
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { useGlobalActionsStore } from "../../stores/GlobalActionsStore";
export default {
  data() {
    return {
      globalStore: useGlobalActionsStore(),
    };
  },
  methods:{
      snackbarClose(val){
          this.globalStore.snackBar.open = val;
      }
  }
};
</script>

<style>
</style>
